"use client";

import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { IoCaretUp, IoCaretDown } from "react-icons/io5";
import { FaArrowTrendUp, FaArrowTrendDown  } from "react-icons/fa6";

import {
  AttachMoney,
  Receipt,
  People,
  AccountBalance,
  MonetizationOn,
} from "@mui/icons-material";

const AccountsCards = ({
  totalBalance = 0,
  totalExpenses = 0,
  totalSalaries = 0,
  currentAgency
}) => {
  // Calculate Profit or Loss
  const profit = totalBalance - (totalSalaries + totalExpenses);
  const isProfit = profit >= 0;

  const stats = [
    {
      label: "Total Income",
      value: totalBalance,
      color: "#16a34a", // green
      icon: <AccountBalance sx={{ color: "#16a34a" }} />,
    },
    {
      label: "Total Expenses",
      value: totalExpenses,
      color: "#dc2626", // red
      icon: <Receipt sx={{ color: "#dc2626" }} />,
    },
    {
      label: "Total Salaries",
      value: totalSalaries,
      color: "#2563eb", // blue
      icon: <People sx={{ color: "#2563eb" }} />,
    },
    {
      label: "Profit / Loss",
      value: profit,
      color: isProfit ? "#16a34a" : "#dc2626", // green if profit else red
      icon: isProfit ? (
        <FaArrowTrendUp style={{ color: "#16a34a", marginLeft: 6 }} />
      ) : (
        <FaArrowTrendDown style={{ color: "#dc2626", marginLeft: 6 }} />
      ),
      endIcon: isProfit ? (
        <IoCaretUp style={{ color: "#16a34a", marginLeft: 6 }} />
      ) : (
        <IoCaretDown style={{ color: "#dc2626", marginLeft: 6 }} />
      ),
    },
  ];
const currency =
    currentAgency?.countryid === 16
      ? "Rs"
      : currentAgency?.countryid === 18
      ? "AED"
      : "";

  return (
    <Grid container spacing={{ xs: 1.5, sm: 2 }} sx={{  }}>
      {stats.map((stat, i) => (
        <Grid item xs={12} sm={6} md={3} key={i} display="flex">
          <Card
            elevation={0}
            sx={{
              width: "100%",
              borderRadius: 2,
              backgroundColor: (t) => t.palette.background.paper,
              position: "relative",
              overflow: "hidden",
              transition: "box-shadow .2s ease, transform .2s ease",
              "&:before": {
                content: '""',
                position: "absolute",
                left: 0,
                top: 0,
                bottom: 0,
                width: "6px",
                background: `linear-gradient(to bottom, ${alpha(
                  stat.color,
                  0.6
                )}, ${alpha(stat.color, 0.2)})`,
              },
              "&:hover": {
                transform: "translateY(-3px)",
                boxShadow: 4,
              },
            }}
          >
            <CardContent
              sx={{
                textAlign: "center",
                py: { xs: 1.5, sm: 2 },
              }}
            >
              {/* Label with Icon */}
              <Typography
                variant="body2"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 0.75,
                  color: stat.color,
                  fontWeight: 600,
                }}
              >
                {stat.icon} {stat.label}
              </Typography>

              {/* Value */}
              <Box
                component="div"
                sx={{
                  mt: 1,
                  color: stat.color,
                  fontWeight: 800,
                  fontSize: { xs: "1.3rem", sm: "1.7rem", md: "1.9rem" },
                  lineHeight: 1.2,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                 {currency} {(Number(stat.value) || 0).toLocaleString("en-PK")}
                {stat.endIcon && stat.endIcon}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AccountsCards;
